import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import { Helmet } from "react-helmet";
import "./style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "components/Footer/Footer";
import ChannelCard from "components/ChannelCard/ChannelCard";
import { org_friendly_url, channel_list_api, HeaderConfig } from "Api/Api";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import axios from "axios";
import { local_routes } from "utils/Routes";
import home from "Assets/home.svg";

let ChannelImg1 =
  "https://static.pechakucha.com/pechakucha/uploads/channel/logo/57159395168963964b000001/small_PK_INSPIRE_Initiative_logo.png";

const Channels = () => {
  const [channel_data, set_channel_data] = useState([]);
  const [loading, set_loading] = useState(true);

  let workspace_base_url = "";
  let Channel_or_Team = "Channel";
  let channel_or_team = "channel";
  let banner_text = `
      Channels are where museums, galleries, companies, and organizations can share a curated lineup of PechaKucha 20x20 presentations, either produced for the site, or recorded at live "Powered by PechaKucha" events.
    `;

  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
    local_routes.channels = local_routes.teams;
    Channel_or_Team = "Team";
    channel_or_team = "team";
    banner_text = `Teams can be used for great things.`;
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(channel_list_api, HeaderConfig);
        response.data.entities.map((item) => {
          if (item.logo_image_url) {
            let array = item.logo_image_url.split("/");
            item.logo_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${array[5]}`;
          }
          set_channel_data(response.data.entities);
          set_loading(false);
        });
      } catch (e) {
        console.log("ERROR:", e);
      }
    };
    getData();
  }, []);

  const channelsChip = () => {
    return (
      <Row>
        {channel_data.map((item) => (
          <Col key={item.entity_uuid} sm={12} md={3} lg={3}>
            <ChannelCard
              key={item.entity_uuid}
              Channels_img={
                item.logo_image_url !== null ? item.logo_image_url : ChannelImg1
              }
              Channels_title={item.entity_name}
              Channels_body={item.description}
              Channels_link={`${workspace_base_url}${local_routes.channels}/${item.friendly_url}`}
              Channel_or_Team={Channel_or_Team}
            />
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <div className="main-section">
      {loading ? (
        <ActivityIndicator theme="spinner" />
      ) : (
        <React.Fragment>
          <Helmet defer={false}>
            <title>PechaKucha {Channel_or_Team}s</title>
          </Helmet>
          <Row style={{ margin: 0 }}>
            <section className="channel-hero">
              <div className="container">
                <Row>
                  <Col sm={12}>
                    <p>{banner_text}</p>
                  </Col>
                </Row>
              </div>
            </section>
          </Row>
          {channel_data.length > 0 && (
            <Container>
              <section className="channels-grid">{channelsChip()}</section>
            </Container>
          )}
          <Footer
            homeImg={home}
            homeImgRef="/"
            breadcrumbSubPage={`${Channel_or_Team}s`}
          />
        </React.Fragment>
      )}
    </div>
  );
};

export default Channels;
